export const CHANNEL_CATEGORY_ASSISTED = 10
export const CHANNEL_CATEGORY_UNASSISTED = 11

export const APPLICATION_TYPE_REGISTRATION = 1
export const APPLICATION_TYPE_MIGRATION = 8
export const APPLICATION_TYPE_TRANSFER = 2
export const APPLICATION_TYPE_AMENDMENT = 3
export const APPLICATION_TYPE_REMOVAL = 4
export const APPLICATION_TYPE_SUSPENSION = 5
export const APPLICATION_TYPE_REINSTATEMENT = 6
export const APPLICATION_TYPE_OBJECTION = 7
//Place holder for corrections application type
export const APPLICATION_TYPE_CORRECTION = 10
export const APPLICATION_TYPE_DEMARCATION_CORRECTION_TRANSFER = 11


export const APPLICATION_CHECK_ID_NUMBER = 27
export const APPLICATION_CHECK_SURNAME = 28
export const APPLICATION_CHECK_FIRST_NAME = 29
export const APPLICATION_CHECK_DATE_OF_BIRTH = 30
export const APPLICATION_CHECK_GENDER = 31
export const APPLICATION_CHECK_ID_CARD_FACE_IMAGE = 32
export const APPLICATION_CHECK_LIVE_FACE_IMAGE = 33
export const APPLICATION_CHECK_DETAILS_ON_CARD_MATCH= 35
export const APPLICATION_CHECK_FACE_LOOKS_FAMILAR= 36


export const APPLICATION_STATUS_NEW = 1
export const APPLICATION_STATUS_PENDING = 2
export const APPLICATION_STATUS_REJECTED = 3
export const APPLICATION_STATUS_APPROVED = 4
export const APPLICATION_STATUS_DRAFT = 5
export const APPLICATION_STATUS_WIDTHDRAWN = 6
export const APPLICATION_STATUS_REFERRED = 7
export const APPLICATION_AWAITING_CORRECTION = 8



export const permissionLookUp = {
    Create: "Create",
    Read: "Read",
    Update: "Update",
    Approve: "Approve",
    Reject: "Reject",
    Delete: "Delete",
    Recommend: "Recommend",
    Withdraw: "Withdraw",
    Referral:"Referral"
};

export const DermacationLevels = {
    Level1: 1,
    Level2: 2,
    Level3: 3,
    Level4: 4,
    Level5: 5,
};


export const dermacationsTypes = [
        { name: "National Assembly Structure", id: 1 },
        { name: "Local Government Structure", id: 2 }
];

export  const dermacationsTypesID = {
    National_Assembly_Structure:1,
    Local_Government_Structure:2
  
}